import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Base64Service } from 'src/app/core/base64.service';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { BlendEvent, ErrCode, SHARE_DETAILS_OPEN_STATE } from 'src/app/shared/models';
import { ShareNewService } from 'src/app/shared/services/share-new.service';
import { ShareService } from 'src/app/shared/services/share.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { IErrorCode, IShareData, ISharememberInviteData } from 'src/sync';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { BlendService } from 'src/app/shared/services/blend.service';

@Component({
  selector: 'app-share-member-invite',
  templateUrl: './share-member-invite.component.html',
  styleUrls: ['./share-member-invite.component.scss']
})
export class ShareMemberInviteComponent implements OnInit, OnDestroy {
  @Input() public shareData: IShareData;
  @Input() public openState: number;
  @Output() openStateChange: EventEmitter<number> = new EventEmitter();

  @Input() showDialog!: boolean;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  name: string = '';
  public spinner: boolean;
  public invitedEmails: string;
  public sharememberInvite: ISharememberInviteData = {
    permissions: {
      perDOWNLOAD: 1,
      perUPLOAD: 1,
      perINVITE: 0,
      perSEEOTHERS: 1,
    },
    displayName: '',
    queue: [],
    roleQueue: [],
    roleName: '',
    privateMessage: '',
  };

  public isPro = false;
  public isVerified = false;
  public errcode: ErrCode;

  public isSmallScreen: boolean = false;
  private breakpointSubscription: Subscription;
  constructor(
    private userService: UserService,
    private base64Service: Base64Service,
    private loggerService: LoggerService,
    private shareService: ShareService,
    public breakpointObserver: BreakpointObserver,
    private shareNewService: ShareNewService,
    private snackbarService: SnackbarService,
    private blendService: BlendService
  ) { }

  ngOnInit() {
    this.breakpointSubscription = this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
    .subscribe((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 599px)']) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
      
    });  

    this.showDialog = true;
    this.isVerified = this.userService.get('is_verified');
    this.isPro = this.userService.get('is_pro');
    this.sharememberInvite.displayName = this.base64Service.decode(
      this.userService.get('display_name')
    );

    if (!this.shareData) {
      this.loggerService.error(
        'Unable to find shareData for sharemember-list'
      );
      this.loggerService.error(JSON.stringify(this.shareData));
      
      this.errcode = ErrCode.fromException({ code: 1000,
        msg: 'No share member information provided', });
    }
    this.name = this.shareData.name;
  }

  ngOnDestroy(): void {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  public isValidInvite(): boolean {
    return (
      this.sharememberInvite.displayName &&
      (this.sharememberInvite.queue.length > 0 || this.sharememberInvite.roleQueue.length > 0)
    );
  }

  public sendInvites = async () => {
    try {
      this.spinner = true;
      this.invitedEmails = '';
      await this.shareNewService.addMember(
        this.shareData,
        this.sharememberInvite
      );
      this.spinner = false;
      this.loggerService.info('Finished adding share member');
      this.invitedEmails = this.sharememberInvite.queue.join(', ');
      if (this.invitedEmails && this.sharememberInvite.roleName) {
        this.invitedEmails += `, ${this.sharememberInvite.roleName}`;
      } else if (!this.invitedEmails && this.sharememberInvite.roleName) {
        this.invitedEmails = this.sharememberInvite.roleName;
      }
      this.invitedEmails = this.invitedEmails.replace(/,(?=[^,]+$)/, ' and');
      this.sharememberInvite.queue = [];
      this.sharememberInvite.roleQueue = [];
      this.sharememberInvite.roleName = '';
      const shareData = await this.shareService.getShare(
        this.shareData.shareId
      );
      this.shareData = shareData;
      this.snackbarService.showMessage('success', `Invitations successfully sent.`)

      this.blendService.track(BlendEvent.INVITE_TO_SHARE, {
        num_users: this.invitedEmails.split(',').length + 1,
        can_download: !!this.sharememberInvite.permissions.perDOWNLOAD,
        can_upload: !!this.sharememberInvite.permissions.perUPLOAD,
        can_invite: !!this.sharememberInvite.permissions.perINVITE,
        can_see_others: !!this.sharememberInvite.permissions.perSEEOTHERS,
      });

    } catch (err) {
      this.spinner = false;
      this.errcode = ErrCode.fromException(err);
      this.snackbarService.showMessage('critical', 'Couldn’t complete action. Try again.');
    }
    this.closeDialog();
  }
  private openPopup(state: number) {
    this.openStateChange.next(state);
  }

  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(state>0 ? true : false);
      this.openPopup(state)
    }, 50);
  }
  onBack = () => {
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.MEMBER_LIST);
  }
  onSend = () => {
    // this.stopShare();
    console.log('onUnshare', 5, this.shareData,
      this.sharememberInvite);
      this.blendService.track(BlendEvent.BUTTON_CLICKED, {
        button_text: 'Invite (to share)',
      })
    this.sendInvites();
    // this.closeDialog(5) 
  }
}
